
export const aChiContent = [
  {
    title: "AI CITTADINI",
    text: "A tutti i cittadini e le cittadine che cercano un corso di Italiano L2 a Milano."
  },
  {
    title: "ALLE SCUOLE DI ITALIANO",
    text: "A tutte le scuole di Italiano L2 interessate a collaborare in rete con il Comune di Milano."
  },
  {
    title: "AI SERVIZI",
    text: "A tutti i servizi della città che necessitano di supporto specialistico sul tema dell'apprendimento della lingua italiana L2."
  },
];

export const cosaFareContent = [
  {
    title: "INFORMAZIONE",
    text: "Per conoscere meglio i corsi di Italiano L2 offerti da istituzioni, scuole e associazioni."
  },
  {
    title: "ORIENTAMENTO",
    text: "Per capire quale è il corso più adatto alle specifiche esigenze di chi vuole apprendere la lingua Italiana."
  },
  {
    title: "INCROCIO DOMANDA E OFFERTA",
    text: "Per avere supporto nella scelta e nell’iscrizione ad un corso di Italiano L2."
  },
];

export const cosaOffreScuolaContent = [
  {
    title: "COLLABORAZIONE CON LE SCUOLE DI ITALIANO ",
    text: "Per facilitare l'integrazione tra le scuole di Italiano L2 e la progettazione di interventi per persone o gruppi con esigenze specifiche."
  },
  {
    title: "CONSULENZA SPECIALISTICA",
    text: "Per ricevere consulenza nella ricerca di corsi di lingua italiana per cittadini e cittadine in temporanea condizioni di vulnerabilità."
  },
];